export default __webpack_public_path__ + "static/media/head04_ko_sp.8059ae97.png";